import { Component, Renderer2, ElementRef, ViewChild } from "@angular/core";
import { Router, NavigationStart, NavigationEnd, NavigationCancel } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { logbaseService } from "../app/services/logbase.service";
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import Swal from 'sweetalert2';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent {
  title = "Fuso - Logbase";
  //modalRef: NgbModalRef;

  // Add dynamic class to the body based on route.
  previousUrl: string;
  packageID: string;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  extendSession = false;
  loggedIn: any;
  idleStart = false;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private logbaseService: logbaseService,
    private idle: Idle, private keepalive: Keepalive
  ) {

    translate.setDefaultLang("jn");
    translate.use("jn");
    if (localStorage.getItem('language')) {
      translate.setDefaultLang(localStorage.getItem('language'));
      translate.use(localStorage.getItem('language'));
    } else {
      translate.setDefaultLang('jn');
      translate.use('jn');
      localStorage.setItem("language", "jn");
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.previousUrl) {
          this.renderer.removeClass(document.body, this.previousUrl);
        }
        let currentUrlSlug = event.url.slice(1);
        if (currentUrlSlug == null || currentUrlSlug == "") {
          this.renderer.addClass(document.body, "homePage");
        }
        if (currentUrlSlug) {
          this.renderer.removeClass(document.body, "homePage");
          this.renderer.addClass(document.body, currentUrlSlug);
        }
        this.previousUrl = currentUrlSlug;
      }
    });
  }

  ngOnInit() {
    var ngidleStatus = localStorage.getItem('ng2Idle.main.idling');
    var currentUser = localStorage.getItem('currentUser');

    if (ngidleStatus == 'false' && currentUser != null) {
      // sets an idle timeout of 5 seconds, for testing purposes.
      this.idle.setIdle(900);
      // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
      this.idle.setTimeout(120);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      this.idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
      this.idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        this.logout();
      });
      this.idle.onIdleStart.subscribe(() => {
        this.idleState = 'You\'ve gone idle!';

        this.idleStart = true;
        this.showSessionExp();
      });
      this.idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');

      // sets the ping interval to 15 seconds
      this.keepalive.interval(900);

      this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

      this.reset();
    }
  };

  switchLanguage(language: string) {
    this.translate.use(language);
  }

  showSessionExp() {

    Swal.fire({
       title: "Session Expiring Soon",
       text: "Due to inactive response , You are going to be logged out soon, Do you want to extend this session?",
       icon: 'warning',
       showConfirmButton: true,
       confirmButtonText: 'Extend Session!',
       confirmButtonColor: "#000000"
    })
  };

  // showSessionExp() {
  //   this.modalRef = this.modalService.open(this.confirmBox);
  //   this.modalRef.result.then((result) => {
  //   });
  // };

  // reset() {
  //   this.idle.watch();
  //   this.idleState = 'Started.';
  //   this.timedOut = false;
  //   this.idleStart = false;
  //   this.modalRef.close();
  // }

  // logout() {
  //   // remove user from local storage to log user out
  //   localStorage.removeItem('currentUser');
  //   localStorage.removeItem('userDetails');
  //   localStorage.removeItem('userToken');
  //   this.modalRef.close();
  //   this.router.navigate(["/login"]);
  // }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('userToken');
    //this.token.clearTokens();
    this.router.navigate(["/login"]);
    Swal.close();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
    this.idleStart = false;
    //this.modalRef.dismiss();
  }

}
